import React from "react";

const INV_COLORS = {
  PAID: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  PENDING: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  UNPAID: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  OVERDUE: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  VOID: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  CANCELLED: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  DRAFT: "bg-slate-500/15 text-slate-300 border-slate-500/30",
};

const PAY_COLORS = {
  SUCCESS: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  PENDING: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  FAILED: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  REFUNDED: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  EXPIRED: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  CANCELLED: "bg-slate-500/15 text-slate-300 border-slate-500/30",
};

const ACC_COLORS = {
  ACTIVE: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  GRACE_PERIOD: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  SUSPENDED: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  EXPIRED: "bg-slate-500/15 text-slate-300 border-slate-500/30",
};

function Base({ label, cls, testid }) {
  return (
    <span className={`inline-flex items-center rounded-full border font-black uppercase tracking-wider text-[10px] px-2 py-0.5 ${cls}`}
      data-testid={testid}>{label}</span>
  );
}

export function InvoiceStatusBadge({ status }) {
  const s = String(status || "DRAFT").toUpperCase();
  return <Base label={s} cls={INV_COLORS[s] || INV_COLORS.DRAFT} testid={`invoice-status-${s.toLowerCase()}`} />;
}
export function PaymentStatusBadge({ status }) {
  const s = String(status || "PENDING").toUpperCase();
  return <Base label={s} cls={PAY_COLORS[s] || PAY_COLORS.PENDING} testid={`payment-status-${s.toLowerCase()}`} />;
}
export function AccountStatusBadge({ status }) {
  const s = String(status || "ACTIVE").toUpperCase().replace(" ", "_");
  return <Base label={s.replace("_", " ")} cls={ACC_COLORS[s] || ACC_COLORS.EXPIRED} testid={`account-status-${s.toLowerCase()}`} />;
}

export function formatIDR(n) {
  const v = Number(n) || 0;
  return "Rp " + v.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}
